module.exports = __webpack_public_path__ + "img/Sccirocco.80a601c1.jpeg";